import {
    LeftOutlined,
    RightOutlined
} from "@ant-design/icons";
import React from "react";
export const CustomPrevArrow = ({ className, style, onClick }) => (
    <div
      className={className}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 25,
        height: 25,
        background: "rgba(0,0,0,0.4)",
        borderRadius: "50%",
        zIndex: 2,
        left: -30,
      }}
      onClick={onClick}
    >
      <LeftOutlined style={{ color: "#fff", fontSize: 15 }} />
    </div>
  );
  
  export const CustomNextArrow = ({ className, style, onClick }) => (
    <div
      className={className}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 25,
        height: 25,
        background: "rgba(0,0,0,0.4)",
        borderRadius: "50%",
        zIndex: 2,
        right: -30,
      }}
      onClick={onClick}
    >
      <RightOutlined style={{ color: "#fff", fontSize: 15 }} />
    </div>
  );